import {Box, Divider, Paper, Typography} from "@mui/material";
import {RankChip} from "./RankChip";
import {formatTimestamp} from "../utils";
import {EditorContent} from "./editor/EditorContent";
import React from "react";

interface MessageBoxWithUserDetailsProps {
    authorCommunityId: string,
    authorNick: string,
    authorRpName: string,
    authorRankDisplayName?: string,
    authorRankColor?: string,
    date: string,
    content: string
}

export const MessageBoxWithUserDetails = (props: MessageBoxWithUserDetailsProps) => {

    return <Paper variant={"outlined"} >
                <Box sx={{p:2}} display="flex" flexWrap="wrap" gap={1}>
                    <RankChip rank={props?.authorRankDisplayName ?? "Unranked"} color={props?.authorRankColor ?? "white"} link={(`/user/${props.authorCommunityId}/`)}/>
                    <RankChip rank={props.authorNick} link={(`/user/${props.authorCommunityId}/`)}/>
                    <RankChip rank={props.authorRpName} color="23C6C8" link={(`/user/${props.authorCommunityId}/`)}/>
                    <Typography variant="subtitle1">
                        {formatTimestamp(props.date)}
                    </Typography>
                </Box>
        <Divider />
        <Box sx={{p:2}}>
            <EditorContent content={props.content}/>
        </Box>
    </Paper>
}